/* ==========================================================================
   HiverCozy — bandeau d'annonce tournant et carrousels (vanilla JS)
   ========================================================================== */
(() => {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Bandeau d'annonce : un message à la fois ---------- */
  document.querySelectorAll('[data-hc-rotator]').forEach((bar) => {
    const items = Array.from(bar.children);
    if (items.length < 2 || reduced) return;
    let i = 0;
    setInterval(() => {
      if (document.hidden) return;
      items[i].classList.remove('is-active');
      items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
      items[i].removeAttribute('aria-hidden');
    }, 4000);
  });

  /* ---------- Carrousels à défilement natif (scroll-snap) ---------- */
  document.querySelectorAll('[data-hc-carousel]').forEach((root) => {
    const track = root.querySelector('[data-hc-track]');
    if (!track) return;
    const dots = root.querySelector('[data-hc-dots]');
    const prev = root.querySelector('[data-hc-prev]');
    const next = root.querySelector('[data-hc-next]');
    let pages = 1;

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const pageCount = () => (maxScroll() < 4 ? 1 : Math.ceil(track.scrollWidth / track.clientWidth - 0.02));
    const current = () => {
      if (track.scrollLeft >= maxScroll() - 4) return pages - 1;
      return Math.round(track.scrollLeft / track.clientWidth);
    };
    const goTo = (p) => {
      const target = Math.min(maxScroll(), Math.max(0, p) * track.clientWidth);
      track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
    };

    const update = () => {
      const c = current();
      if (dots) Array.from(dots.children).forEach((d, k) => {
        d.classList.toggle('is-active', k === c);
        d.setAttribute('aria-current', k === c ? 'true' : 'false');
      });
      if (prev) prev.disabled = c <= 0;
      if (next) next.disabled = c >= pages - 1;
    };

    const build = () => {
      pages = pageCount();
      root.classList.toggle('is-static', pages <= 1);
      if (dots) {
        dots.innerHTML = '';
        for (let k = 0; k < pages; k++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', `Aller à la page ${k + 1} sur ${pages}`);
          b.addEventListener('click', () => goTo(k));
          dots.appendChild(b);
        }
      }
      update();
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    }, { passive: true });
    if (prev) prev.addEventListener('click', () => goTo(current() - 1));
    if (next) next.addEventListener('click', () => goTo(current() + 1));

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 150);
    });
    build();

    /* Défilement automatique (carrousel d'accueil), en pause au survol ou au focus */
    const delay = parseInt(root.dataset.hcAutoplay || '0', 10);
    if (delay > 0 && !reduced) {
      let paused = false;
      ['pointerenter', 'focusin', 'touchstart'].forEach((e) => root.addEventListener(e, () => { paused = true; }, { passive: true }));
      ['pointerleave', 'focusout'].forEach((e) => root.addEventListener(e, () => { paused = false; }));
      setInterval(() => {
        if (paused || document.hidden || pages <= 1) return;
        goTo((current() + 1) % pages);
      }, delay * 1000);
    }
  });
})();
